import apiFetch from '../apiFetch'

export default function (token, documentId, organizedUnitId) {
  return apiFetch({ endPoint: `Document/Metadata/${documentId}/Extract?organizedUnitId=${organizedUnitId}`, method: 'GET', body: null, token: token })
}
